// extracted by mini-css-extract-plugin
module.exports = {"selector":"SolidSelect_selector__1N6MY","input":"SolidSelect_input__1doZ3","indicator":"SolidSelect_indicator__3l_EB"};